import { render, staticRenderFns } from "./ThePublicActions.vue?vue&type=template&id=5c857240&scoped=true&"
import script from "./ThePublicActions.vue?vue&type=script&lang=js&"
export * from "./ThePublicActions.vue?vue&type=script&lang=js&"
import style0 from "./ThePublicActions.vue?vue&type=style&index=0&id=5c857240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c857240",
  null
  
)

export default component.exports